<template>
  <div>
    <v-data-table
      v-model="itemsSelectedWithValidRebate"
      dense
      :headers="tableHeaders"
      :items="data"
      item-key="MVGR4"
      :search="search"
      class="main-table"
      height="auto"
      :show-select="!hideSelect"
      :items-per-page="itemsPerPage"
      :item-class="rowClass"
      :footer-props="{ 'items-per-page-options': [itemsPerPage] }"
    >
      <template #[`header.data-table-select`]="{ props, on }">
        <div>Exportar a Excel</div>
        <v-simple-checkbox
          v-model="selectAll"
          :indeterminate="props.indeterminate"
          v-on="on"
        />
      </template>
      <template #[`item.data-table-select`]="{ item, isSelected, select }">
        <v-simple-checkbox
          v-if="isSelectable(item)"
          :value="isSelected"
          @input="select($event)"
        />
      </template>
      <template #[`item.FCCUOTA`]="{ item }">
        <div>{{ formatNumber(item.FCCUOTA, '') }}</div>
      </template>
      <template #[`item.FKIMGKG`]="{ item }">
        <div>{{ formatNumber(item.FKIMGKG, '') }}</div>
      </template>
      <template #[`item.NETWR1`]="{ item }">
        <div>$ {{ formatNumber(item.NETWR1, '') }}</div>
      </template>
      <template #[`item.PORCENA`]="{ item }">
        <div>{{ formatNumber(item.PORCENA, '') }}</div>
      </template>
      <template #[`item.REBATNC`]="{ item }">
        <div>$ {{ formatNumber(item.REBATNC, '') }}</div>
      </template>
      <template v-if="!hideTotal" #foot>
        <tfoot>
          <tr>
            <td colspan="9" class="text-right foot-total">
              <b class="font-desing"
                >Total Bono Rebate: ${{ total | formatCurrency }}</b
              >
            </td>
          </tr>
        </tfoot>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import numbersFormats from '@/mixins/numbersFormats';
  export default {
    name: 'RebateDetailTable',
    mixins: [numbersFormats],
    props: {
      data: {
        type: Array,
        required: true,
      },
      search: {
        type: String,
        default: '',
      },
      hideHeaders: {
        type: Array,
        default: () => [],
      },
      itemsPerPage: {
        type: Number,
        default: 5,
      },
      hideSelect: Boolean,
      hideTotal: Boolean,
    },
    data() {
      return {
        headers: [
          { text: '', value: 'data-table-select' },
          { text: 'Gp4', value: 'MVGR4' },
          { text: 'Descripción', value: 'BEZEI' },
          { text: 'Unidad de Medida', value: 'MEINS' },
          { text: 'Cuota', value: 'FCCUOTA' },
          { text: 'Facturado Kg/Pza', value: 'FKIMGKG' },
          { text: 'Facturado monto', value: 'NETWR1' },
          { text: 'Avance %', value: 'PORCENA' },
          { text: 'Bono Rebate', value: 'REBATNC' },
        ],
        selectAll: false,
      };
    },
    computed: {
      tableHeaders() {
        const hiddenHeadersList = [
          ...(this.hideSelect ? ['data-table-select'] : []),
          ...this.hideHeaders,
        ];

        return this.headers.filter(
          (header) => !hiddenHeadersList.includes(header.value)
        );
      },
      total() {
        return this.data.reduce(
          (sum, item) => sum + Number(item.REBATNC || 0),
          0
        );
      },
      itemsSelectedWithValidRebate: {
        set(newValue) {
          const items = newValue.filter((i) => this.isSelectable(i));
          this.$emit('itemSelected', items);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      isSelectable(item) {
        return item.REBATNC !== '0.00';
      },
      rowClass(item) {
        return !this.isSelectable(item) ? 'disabled-row' : '';
      },
    },
  };
</script>

<style scoped src="@/assets/css/table.css"></style>
<style scoped>
  .foot-total {
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029 !important;
    background-color: rgb(242, 242, 242);
  }
  .font-desing {
    font-size: 20px;
    margin-right: 50px;
  }
  ::v-deep .disabled-row td {
    color: #9e9e9e !important;
  }
  ::v-deep .v-data-footer {
    justify-content: flex-end;
  }
</style>
